/* eslint-disable @typescript-eslint/naming-convention */
import { LocalFontSource } from 'app.configuration';


export function CreateFontFaceRule(domain: string, font: LocalFontSource): string {
  return `
    @font-face {
      font-family: "${font.name}";
      font-style: "${font.fontStyle ?? 'normal'}"
      font-weight: "${font.fontWeight ?? 'normal'}"
      src: url("${domain}/${font.path}/${font.name}.eot");
      src:
        url("${domain}${font.path}${font.name}.eot?#iefix") format("embedded-opentype"),
        url("${domain}${font.path}${font.name}.woff2") format("woff2"),
        url("${domain}${font.path}${font.name}.woff") format("woff"),
        url("${domain}${font.path}${font.name}.ttf") format("truetype");
    }`;
}

export function AddFontFaceRulesToDOM(document: Document | ShadowRoot, domain: string, fonts: LocalFontSource[]): void {
  // The stylesheet cannot be from an external domain.
  const style = Array.from(document.styleSheets).find(
    (styleSheet) => !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
  );

  if (style?.cssRules) {
    fonts.forEach((font) => {
      const fontFaceRule = CreateFontFaceRule(domain, font);
      style.insertRule(fontFaceRule, style.cssRules.length);
    });
  }
}
